export default __webpack_public_path__ + "static/media/comm 2.1bac84d0.jpg";